<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Editar Técnico" @close="$refs.dialog.$dismiss()" />
      <v-card-text class="pa-3 children-pa-3">
        <div>
          <v-text-field v-model="row.name" label="Nome" hide-details />
        </div>
        <div>
          <OMoneyInput
            v-model="row.installValue"
            label="Valor Instalação"
            hideDetails
          />
        </div>
        <div>
          <OMoneyInput
            v-model="row.removeValue"
            label="Valor Remoção"
            hideDetails
          />
        </div>
        <div>
          <v-select
            v-model="row.depotId"
            label="Estoque associado"
            clearable
            hide-details
            :items="allDepots"
            item-text="name"
            item-value="id"
          />
        </div>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="$refs.dialog.$dismiss()"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Technician, Depot, minMs5 } from '@/models'
import OMoneyInput from 'oderon-vue/cpts/OMoneyInput'

export default {
  components: {
    OMoneyInput
  },
  data() {
    return {
      row: null,
      allDepots: []
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      this.allDepots = await Depot.findAll()
      this.row = await Technician.findById(this.id)
    },
    async apply() {
      await this.$refs.dialog.$loading(async () => {
        let { name, depotId, installValue, removeValue } = this.row
        await minMs5(
          Technician.patch(this.row.id, {
            name,
            depotId,
            installValue,
            removeValue
          })
        )
      })

      this.$refs.dialog.$dismiss()
      this.$emit('reload')
    }
  }
}
</script>

<style></style>
